import { Box, Divider, Text } from '@chakra-ui/react'
import { ItList } from 'types/graphql'

import { BrandColor } from 'src/types'
import ExpandableText from 'src/components/widgets/ExpandableText/ExpandableText'

const Disclaimer: React.FC<{
  itList: ItList
  brandColor: BrandColor
  isPreview: boolean
  locked: boolean
}> = ({ itList, isPreview, locked, brandColor }) => {
  if (locked || !itList.disclaimer || !itList.showDisclaimer) return null

  return (
    <Box px={{ base: 4, lg: isPreview ? 4 : 24 }}>
      <Divider />
      <Text className="body-small-emphasis" fontSize="14px" mt={6}>
        Disclaimer
      </Text>
      <ExpandableText
        className="body-extra-small"
        color="stone"
        mt={2}
        text={itList.disclaimer}
        expandCollapseButtonProps={{
          textColor: brandColor,
          labelExpanded: 'Less',
          labelCollapsed: 'More',
        }}
      />
    </Box>
  )
}

export default Disclaimer
